import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"  
  formContent: {
    position: 'relative !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    margin: theme.spacing(1)
  },
  title: {
    fontWeight: 600,
    // fontSize: 24,
    marginTop: theme.spacing(1),
    color:  theme.palette.primary.color,
    opacity: 1,
    width: '100% !important',
    textAligment: 'left',
  },
  subTitle: {
    // fontSize: 18,
    // marginTop: theme.spacing(2),
    marginTop: theme.spacing(1),
    textAlign: 'left',
    letterSpacing: 0,
    color:  theme.palette.primary.color,
    opacity: 1,
    width: '100% !important',
  },
  titleSub: {
    fontWeight: 600,
    // fontSize: 18,
    // marginTop: theme.spacing(2),
    marginTop: theme.spacing(1),
    // textAlign: 'left',
    // letterSpacing: 0,
    // color:  theme.palette.primary.color,
    // opacity: 1,
    width: '100% !important',
  },
  confirmTitle: {
    fontWeight: 'bold',
    // fontSize: 28,
    marginTop: theme.spacing(2),
    color:  theme.palette.primary.color,
    opacity: 1,
    width: '100% !important',
    textAligment: 'left',
  },
  confirmSubTitle: {
    marginTop: theme.spacing(1),
    textAlign: 'left',
    letterSpacing: 0,
    color:  theme.palette.primary.color,
    opacity: 1,
    width: '100% !important',
  },
  margin: {
    margin: theme.spacing(1),
  },
  passBtn: {
    display: 'flex',
    //outline: 'solid 1px tomato !important',
    width: '100% !important',
    justifyContent: 'flex-end'
  },
  loginButton: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(4)
  },
  topImage: {
    padding: theme.spacing(1),
  },
  captionRegister: {
    width: '100% !important',
  },
  formControl: {
    // marginTop: '10% !important',
    // margin: theme.spacing(2),
    marginTop: '7px !important',
    width: '100% !important',
    // marginBottom: '7px !important',
    textAlign: 'left',
    '&.MuiFormControlLabel-root label': {
      marginBottom: '0px !important',
      color: `${theme.palette.check.text} !important`,
    }
  },
  button: {
    margin: theme.spacing(1, 1, 0, 0),
  },
  formLabel: {
    // fontSize: 19,
    textAlign: 'left',
    color: `${theme.palette.check.text} !important`,
    opacity: 1,
    marginBottom: '0px !important',
    '&:hover': {
      color: `${theme.palette.check.text} !important`,
    },
    '&:active': {
      color: `${theme.palette.check.text} !important`,
    },
    '&:focus': {
      color: `${theme.palette.check.text} !important`,
    },
  },
  questionContainer: {
    position: 'relative !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    ['@media only screen and (max-width: 812px)']: {
      alignItems: 'center !important',
    },
    justifyContent: 'center !important',
    width: '80% !important',
  },
  cardHeader: {
    width: '100% !important',
    marginTop: 0,
    marginBottom: 0,
    borderBottom: '1px solid red'
  },
  TabLabel: {
    width: '50% !important',
    maxWidth: '100% !important',
    fontWeight: 'bold',
    letterSpacing: '0.15px',
    outline: 'none',
    color: `${theme.palette.tab.text} !important`,
    ['@media only screen and (max-width: 812px)']: {
      width: '50% !important',
      outline: 'none',
    }
  },
  contentTabs: {
    marginTop: '15px !important',
    backgroundColor: '#F2F2F2 !important'
  },

  continueBtn: {
    alignSelf: 'center',
  },
  continueBtnDisabled: {
    alignSelf: 'center',
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important'
  },

  ButtonLogin: {
    margin: theme.spacing(0.5),
    // marginTop: theme.spacing(3)
  },
  ButtonLogindisabled: {
    margin: theme.spacing(0.5),
    // marginTop: theme.spacing(3),
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important'
  },
  fclClassName: {
    marginRight: '0px !important'
  },
  checksList: {
    // width: '100% !important',
    // marginTop: '2% !important',
    marginTop: '0px !important',
    opacity: 1,
    borderRadius: 6,
    // backgroundColor: '#fff',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // paddingTop: '5px !important',
    paddingTop: '0px !important',
    // paddingBottom: '5px !important',
    // marginTop: '10px !important',
    marginBottom: '7px !important',
  },

  container: {
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '50% 50%',
    },
    overflowY: 'none',
    backgroundColor: '#FFFFFF'
  },
  leftColumn: {
    overflowY: 'none',
    margin: 15,
    backgroundColor: '#f2f2f2',
    ['@media only screen and (max-width: 812px)']: {
      overflowY: 'none',
      margin: 15,
      backgroundColor: '#f2f2f2',
    },
  },
  rightColumn: {
    overflowY: 'none',
    margin: 15,
    backgroundColor: '#f2f2f2',
    ['@media only screen and (max-width: 812px)']: {
      overflowY: 'none',
      margin: 15,
      backgroundColor: '#f2f2f2',
    },
  },
  dInline: {
    display: 'inline'
  },
  dNone: {
    display: 'none'
  },
  lineLogin: {
    marginTop:`1px asolid ${theme.palette.primary.color}`,
    marginRight: 0,
    marginLeft: 0,
    marginBottom: '5% !important',
    width: '100%',
  },

  containerLine: {
    display: 'grid !important',
    height: '5px !important',
    gridTemplateColumns: '48% 4% 48%',
    // eslint-disable-next-line
    ['@media only screen and (max-width: 812px)']: {
      // gridTemplateColumns: '5% 90% 5%',
      gridTemplateColumns: '48% 4% 48%',
    },
    gridAutoRows: '2px !important',
    overflowY: 'hidden !important',
    backgroundColor: '#FFFFFF !important',
    paddingTop: '5%',
    paddingBottom: '5%',
  },
  centerColumnLine: {
    display: 'flex !important',
    textAalign: 'center !important',
    justifyContent: 'center !important',
    alignItems: 'center',
    fontSize: '20px',
    '&::-webkit-scrollbar': {
      textAalign: 'center !important',
      justifyContent: 'center !important',
      fontSize: '20px',
      // width: '0',  /* Remove scrollbar space */
      // background: 'transparent',  /* Optional: just make scrollbar invisible */
    },
    overflowX: 'none',
  },
  leftColumnLine: {
    overflowY: 'none',
    height: `1px solid ${theme.palette.primary.color}`,
    backgroundColor: '#f2f2f2',
    ['@media only screen and (max-width: 812px)']: {
      overflowY: 'none',
      height: `1px solid ${theme.palette.primary.color}`,
      backgroundColor: '#f2f2f2',
    },
  },
  rightColumnLine: {
    overflowY: 'none',
    height: `1px solid ${theme.palette.primary.color}`,
    backgroundColor: '#f2f2f2',
    ['@media only screen and (max-width: 812px)']: {
      overflowY: 'none',
      height: `1px solid ${theme.palette.primary.color}`,
      backgroundColor: '#f2f2f2',
    },
  },
  helpIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    margin: 5,
  },
  instructions: {
    marginTop: theme.spacing(2),
    textAlign: 'left',
    // font: 16,
    letterSpacing: '0.53px',
    color:  theme.palette.primary.color,
    opacity: 1
  },
  tittleCopyright: {
    fontSize: 15,
    marginTop: theme.spacing(1),
    textAlign: 'center',
    letterSpacing: 0,
    opacity: 1,
    width: '100% !important',
    color: '#898B8D',
    marginBottom: theme.spacing(2),
  },
}))
